import { motion } from "framer-motion";
import { useLang } from "../context/LangContext";
import { translations } from "./translation";
import { useTheme } from "../context/ThemeContext";

export default function Venue() {
  const { lang } = useLang();
  const { mode, theme } = useTheme();

  return (
    <section
      style={{
        position: "relative",
        padding: "120px 20px",
        color: theme.text,
        backgroundImage:
          "url('https://vesti.kg/media/k2/items/cache/27c2f9522c3000821565647817d33d7e_XL.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* 🌑 Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            mode === "dark" ? "rgba(0,0,0,0.7)" : "rgba(255,255,255,0.6)", // 🔥 светлая тема
        }}
      />

      {/* 🌈 Gradient */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            mode === "dark"
              ? "linear-gradient(to right, rgba(0,0,0,0.9), rgba(0,0,0,0.4))"
              : "linear-gradient(to right, rgba(255,255,255,0.9), rgba(255,255,255,0.3))",
        }}
      />

      {/* CONTENT */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1100px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          alignItems: "center",
        }}
      >
        {/* LEFT */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          style={{ flex: "1 1 300px" }}
        >
          <div
            style={{
              fontSize: "14px",
              color: theme.secondaryText,
              marginBottom: "10px",
              textTransform: "uppercase",
            }}
          >
            {translations.venueTitle[lang]}
          </div>

          <h2
            style={{
              fontSize: "clamp(24px, 4vw, 38px)",
              marginBottom: "15px",
              color: "#555",
            }}
          >
            {translations.venueCity[lang]}
          </h2>

          <div
            style={{
              color: theme.secondaryText,
              lineHeight: 1.6,
            }}
          >
            {translations.venueAddress[lang].split("\n").map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
          </div>
        </motion.div>

        {/* MAP */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          style={{
            flex: "1 1 400px",
            borderRadius: "16px",
            overflow: "hidden",
            border: `1px solid ${theme.border}`,
            background: theme.card,
          }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6963.613282675996!2d74.58326747832169!3d42.79175921490659!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x389eca7ac0000001%3A0x4d57881009c2891a!2z0JPQvtGB0YPQtNCw0YDRgdGC0LLQtdC90L3QsNGPINGA0LXQt9C40LTQtdC90YbQuNGPICLQkNC70LAt0JDRgNGH0LAtMSI!5e0!3m2!1sru!2skg!4v1776835171356!5m2!1sru!2skg"
            width="100%"
            height="350"
            style={{ border: 0 }}
            loading="lazy"
          ></iframe>
         
        </motion.div>
      </div>
    </section>
  );
}
